export default __webpack_public_path__ + "static/media/O-068.afd019d0.png";